import axiosBase from 'axios'
import Constants from '../../constants'

const Axios = {
  setup: function () {
    const a = axiosBase.create({
      baseURL: Constants.BUS_LOCATION_API_URL,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': Constants.BUS_LOCATION_API_KEY,
      },
      responseType: 'json'
    })

    return a
  }
}

export default Axios
